import { ArrowRight, Building2, X } from "lucide-react";

type SetupMeetingBannerProps = {
	// Opens the setup meeting modal.
	onScheduleClick: () => void;
	onClose: () => void;
};

/**
 * Narrow banner at the top of the Ollie dashboard that reminds the user to book the setup meeting.
 * SetupMeetingPrompt decides when it shows.
 */
const SetupMeetingBanner = ({ onScheduleClick, onClose }: SetupMeetingBannerProps) => {
	return (
		<div className="setup-meeting-banner" role="status">
			<Building2 size={16} className="setup-meeting-banner-icon" />
			<span className="setup-meeting-banner-title">Finish setting up your Ollie</span>
			<span className="setup-meeting-banner-description">Free 30-minute setup with our team.</span>
			<button type="button" className="setup-meeting-banner-schedule-button" onClick={onScheduleClick}>
				Schedule setup
				<ArrowRight size={12} />
			</button>
			<button type="button" className="setup-meeting-banner-close-button" aria-label="Close" onClick={onClose}>
				<X size={16} />
			</button>
		</div>
	);
};

export default SetupMeetingBanner;
